import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPurchaseOrders = () => import('./staff/purchaseOrders')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'PurchaseOrdersStaffDashboard',
  purchaseOrders: 'PurchaseOrdersStaffPurchaseOrders',
}

const router =
  [
    {
      path: '/st/purchase-orders',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Orden de compra',
          }          
        },
        {
          path: 'orders',
          name: VIEWS.purchaseOrders,
          component: ViewStaffPurchaseOrders,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de ordenes de compra',
          }
        },
      ]
    },

    {
      path: '/cu/purchase-orders',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/purchase-orders',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
